/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { bool, element, node, oneOfType, shape, string } from 'prop-types';
import setClass from '../../common/set-class';
import Button from '../../atoms/button';
import { useDropdownContext } from '../../atoms/dropdown';
function PopoverHeader({ withCloseButton, title, classes }) {
    const { close } = useDropdownContext();
    if (!title && !withCloseButton) {
        console.warn('Empty PopoverHeader');
        return null;
    }
    return (React.createElement("div", { className: setClass([
            'b-popover__header',
            withCloseButton && 'b-popover__header_with-button',
        ]) },
        title && (React.createElement("div", { className: setClass(['b-txt-ctrl1', classes?.title]) }, title)),
        withCloseButton && (React.createElement(Button, { icon: "xmark", className: "b-popover__close-button", onClick: (e) => {
                if (close) {
                    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                    close(e);
                }
            }, kind: "link" }))));
}
PopoverHeader.propTypes = {
    withCloseButton: bool,
    title: string,
    classes: shape({
        root: string,
        title: string,
    }),
};
PopoverHeader.defaultProps = {
    withCloseButton: false,
    title: null,
    classes: null,
};
function PopoverBlock({ children, className, ...otherProps }) {
    return (React.createElement("div", { className: className, ...otherProps }, children));
}
PopoverBlock.propTypes = {
    children: oneOfType([node, element]).isRequired,
    className: string,
};
PopoverBlock.defaultProps = {
    className: null,
};
export { PopoverHeader, PopoverBlock };
